export default __webpack_public_path__ + "static/media/sweet_potato_veggies.a5ee01a3.jpg";